import PropTypes from 'prop-types';
import classnames from 'classnames';

// styles
import styles from './SearchBar-style.scss';

export const SearchBarTerm = props => {
    const {
        href,
        term,
        handleRowClick,
        cursorHighlightId,
        id,
        termElements,
        termsClassName,
    } = props;
    const searchBarTermClasses = classnames(styles.item, {
        [styles.active]: id === cursorHighlightId,
        [termsClassName]: !!termsClassName,
    });

    return (
        <div className={searchBarTermClasses}>
            <a
                data-tn="search-bar-term"
                className={styles.link}
                href={href}
                onClick={e => {
                    e.preventDefault();
                    handleRowClick(term, href);
                }}
            >
                {termElements}
            </a>
        </div>
    );
};

SearchBarTerm.propTypes = {
    termsClassName: PropTypes.string,
    term: PropTypes.string,
    termElements: PropTypes.any,
    href: PropTypes.string,
    handleRowClick: PropTypes.func,
    cursorHighlightId: PropTypes.string,
    id: PropTypes.string,
};
